import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import PropTypes from 'prop-types';
import MobileNullView from './MobileNullView';
import DesktopNullView from './DesktopNullView';
import fallbackViewTexts from '../../constants/fallbackViewTexts';
import { showDesktopLayout, showMobileLayout } from '../../constants/responsiveClassNames';

const ProjectsNullView = ({ componentId }) => {
  const experienceContext = useContext(ExperienceContext);

  const {
    cardTitle,
    bodyText,
    imageAlt,
    imageUrl,
    buttonText,
    buttonTextDesktop,
    learnMoreText
  } = fallbackViewTexts;

  return (
    <div className="sui-@container sui-h-full">
      <div className={`sui-h-full ${showMobileLayout}`}>
        <MobileNullView
          cardTitle={cardTitle}
          bodyText={bodyText}
          imageUrl={imageUrl}
          imageAlt={imageAlt}
          buttonText={buttonText}
          learnMoreText={learnMoreText}
          componentId={componentId}
        />
      </div>
      <div className={`sui-h-full ${showDesktopLayout}`}>
        <DesktopNullView
          cardTitle={cardTitle}
          bodyText={bodyText}
          imageUrl={imageUrl}
          imageAlt={imageAlt}
          buttonText={buttonTextDesktop}
          learnMoreText={learnMoreText}
          componentId={componentId}
        />
      </div>
    </div>
  );
};

ProjectsNullView.propTypes = {
  componentId: PropTypes.string,
};

ProjectsNullView.defaultProps = {
  componentId: '',
};

export default ProjectsNullView;
